import React from 'react';
import { Grid, Typography } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { InputV2 } from 'components';
import Switch from '@mui/material/Switch';

const MoreSettings = () => {
  const methods = useFormContext();

  return (
    <>
      <Grid container item xs={12} direction="row" alignItems="center">
        <Grid item xs={4}>
          <Typography>
            حداکثر مدت زمان پاسخگویی <small>(بر حسب ثانیه)</small>
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <InputV2
            label="حداکثر مدت زمان پاسخگویی"
            showLabel={false}
            fullWidth={false}
            errors={methods.formState.errors}
            name="timeout"
            register={methods.register}
            currency
            currencyText="ثانیه"
            control={methods.control}
          />
        </Grid>
      </Grid>

      <Grid container item xs={12} alignItems="center">
        <Grid item xs={4}>
          <Typography>ارسال پیامک تخفیف برای صاحب سرویس</Typography>
        </Grid>
        <Grid item xs={4}>
          {/* <RadioGroupPod
            control={methods.control}
            name="scSendVoucherSMS"
            defaultValue="false"
            options={[
              {
                label: 'بله',
                value: 'true'
              },
              {
                label: 'خیر',
                value: 'false'
              }
            ]}
          /> */}
          <Controller
            name="scSendVoucherSMS"
            control={methods.control}
            defaultValue={false}
            register={methods.register}
            render={({ field: props }) => (
              <Switch
                color="primary"
                checked={props.value}
                className='iosSwitch'
                onChange={(e) => props.onChange(e.target.checked)}
              />
            )}
          />
        </Grid>
      </Grid>

      <Grid container item xs={12} alignItems="center">
        <Grid item xs={4}>
          <Typography>در فراخوانی سرویس (scApiKey) ارسال و عدم ارسال کلید اتصال</Typography>
        </Grid>
        <Grid item xs={4}>
          {/* <RadioGroupPod
            control={methods.control}
            name="scSendApiKey"
            defaultValue="true"
            options={[
              {
                label: 'بله',
                value: 'true'
              },
              {
                label: 'خیر',
                value: 'false'
              }
            ]}
          /> */}
          <Controller
            name="scSendApiKey"
            control={methods.control}
            defaultValue
            render={({ field: props }) => (
              <Switch
                color="primary"
                checked={props.value}
                className='iosSwitch'
                onChange={(e) => props.onChange(e.target.checked)}
              />
            )}
          />
        </Grid>
      </Grid>

      <Grid container item xs={12} alignItems="center">
        <Grid item xs={4}>
          <Typography>دریافت پاسخ از سرویس دیگر</Typography>
        </Grid>
        <Grid item xs={4}>
          {/* <RadioGroupPod
            control={methods.control}
            name="scIsCallback"
            defaultValue="false"
            options={[
              {
                label: 'بله',
                value: 'true'
              },
              {
                label: 'خیر',
                value: 'false'
              }
            ]}
          /> */}
          <Controller
            name="scIsCallback"
            control={methods.control}
            defaultValue={false}
            render={({ field: props }) => (
              <Switch
                color="primary"
                checked={props.value}
                className='iosSwitch'
                onChange={(e) => props.onChange(e.target.checked)}
              />
            )}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default MoreSettings;
